export default "__VITE_ASSET__$j03QU_f__"